/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_No_Active_PlanInputs */

const en_plan_no_active_plan = /** @type {(inputs: Plan_No_Active_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active plan`)
};

const es_plan_no_active_plan = /** @type {(inputs: Plan_No_Active_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay un plan activo`)
};

/**
* | output |
* | --- |
* | "No active plan" |
*
* @param {Plan_No_Active_PlanInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_no_active_plan = /** @type {((inputs?: Plan_No_Active_PlanInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_No_Active_PlanInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_no_active_plan(inputs)
	return en_plan_no_active_plan(inputs)
});